import ConstrainBase from "../ConstrainBase";
import ValidationResult from "../ValidationResult";

/**
 * class FloatConstrain
 * Validiert Dezimalzahlen analog zur serverseitigen FloatConstrain.php
 */
class FloatConstrain extends ConstrainBase {

  validate(value) {
    if (value === null || value === undefined || value === '') {
      return new ValidationResult(true, '');
    }
    // Komma als Dezimaltrennzeichen akzeptieren (deutsch)
    const normalized = String(value).replace(',', '.');
    if (isNaN(parseFloat(normalized)) || !isFinite(normalized)) {
      return new ValidationResult(false, 'Bitte eine gültige Zahl eingeben.');
    }
    return new ValidationResult(true, '');
  }
}

export default FloatConstrain;
